export function isRestrictedViewUser() {
  return $tlf.permissions.userRoles.includes('restricted_view');
}
